import { Reducer } from 'redux';
import { update } from '../helpers/immutabilityHelper'
import * as Dtos from '../dtos/Tmd.dtos';

import {
    ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_LOAD,
    ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_LOAD_BY_ID,
    ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_LOAD_FAILURE,
    ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_LOAD_SUCCESS,

    ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_SAVE,
    ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_SAVE_SUCCESS,
    ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_SAVE_FAILURE,

    ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_CREATE,
    ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_CREATE_SUCCESS,
    ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_CREATE_FAILURE,

    ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_VALIDATE,
    ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_VALIDATE_SUCCESS,
    ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_VALIDATE_FAILURE,

    ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_CLEAR,
    ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_FILTER,

    TrialGroupItemTemplateCategoryAction
} from '../actions/trialGroupItemTemplateCategories';
import { RequestState } from "../enumerations/RequestState";
import { IRequestState, IFormFilter } from "./index";
import { updateFailureIndexToId } from "../helpers/formErrorHelper";

export interface ITrialGroupItemTemplateCategoryState {
    formData: Dtos.TrialGroupItemTemplateCategory | Dtos.TrialGroupItemTemplateCategory[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    validationFailures: Dtos.ResponseError[];
    lookups: Dtos.Lookup[];
    loadState: IRequestState;
    saveState: IRequestState;
    updateState: IRequestState;
    createState: IRequestState;
    validateState: IRequestState;
    formFilter: IFormFilter;
    formFilteredData: Dtos.TrialGroupItemTemplateCategory[];
}

const initialState: ITrialGroupItemTemplateCategoryState = {
    formData: undefined,
    formState: undefined,
    formProperties: undefined,
    validationFailures: undefined,
    lookups: undefined,
    loadState: {
        status: RequestState.None
    } as IRequestState,
    saveState: {
        status: RequestState.None
    } as IRequestState,
    updateState: {
        status: RequestState.None
    } as IRequestState,
    createState: {
        status: RequestState.None
    } as IRequestState,
    validateState: {
        status: RequestState.None
    } as IRequestState,
    formFilter: {
        search: "",
        showInActive: false
    },
    formFilteredData: []
};


function loading(state: ITrialGroupItemTemplateCategoryState, _isLoading: boolean): ITrialGroupItemTemplateCategoryState {
    const newState: ITrialGroupItemTemplateCategoryState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function loadSuccess(state: ITrialGroupItemTemplateCategoryState,
    formData: Dtos.TrialGroupItemTemplateCategory | Dtos.TrialGroupItemTemplateCategory[],
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[],
    responseStatus: Dtos.ResponseStatus
): ITrialGroupItemTemplateCategoryState {
    const newState: ITrialGroupItemTemplateCategoryState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        loadState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return filter(newState, state.formFilter);
}

function filter(state: ITrialGroupItemTemplateCategoryState, formFilter: IFormFilter): ITrialGroupItemTemplateCategoryState {

    const trialGroupItemTemplateCategories: Dtos.TrialGroupItemTemplateCategory[] | undefined =
        state.formData instanceof Array ?
            state.formData :
            undefined;

    const formFilteredData = trialGroupItemTemplateCategories ? trialGroupItemTemplateCategories.filter(p => (p.active == true || formFilter.showInActive) &&
        (formFilter.search == "" || p.value.toLowerCase().indexOf(formFilter.search.toLowerCase()) > -1)) : undefined;

    const newState: ITrialGroupItemTemplateCategoryState = update(state, {
        formFilter: {
            $set: formFilter
        },
        formFilteredData: {
            $set: formFilteredData
        }
    });

    return newState;
}

function loadFailure(state: ITrialGroupItemTemplateCategoryState, responseStatus: Dtos.ResponseStatus): ITrialGroupItemTemplateCategoryState {
    const newState: ITrialGroupItemTemplateCategoryState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors
            } as IRequestState
        }
    });

    return newState;
}

function clear(state: ITrialGroupItemTemplateCategoryState, propertiesToClear?: string[]): ITrialGroupItemTemplateCategoryState {

    if (!propertiesToClear) {
        let formFilter = state.formFilter;
        const newState: ITrialGroupItemTemplateCategoryState = update(initialState, {
            formFilter: {
                $set: formFilter
            }
        });
        return newState;
    }

    let stateModifier: any = {};

    propertiesToClear.forEach(propertyToClear => {
        stateModifier[propertyToClear] = { $set: initialState[propertyToClear] }
    });

    const newState = update(state, stateModifier);

    return newState;
}

function saving(state: ITrialGroupItemTemplateCategoryState, _isSaving: boolean): ITrialGroupItemTemplateCategoryState {
    const newState: ITrialGroupItemTemplateCategoryState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function saveSuccess(
    state: ITrialGroupItemTemplateCategoryState,
    formData: Dtos.TrialGroupItemTemplateCategory | Dtos.TrialGroupItemTemplateCategory[],
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus
): ITrialGroupItemTemplateCategoryState {
    const newState: ITrialGroupItemTemplateCategoryState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        saveState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function saveFailure(state: ITrialGroupItemTemplateCategoryState, responseStatus: Dtos.ResponseStatus): ITrialGroupItemTemplateCategoryState {
    const newState: ITrialGroupItemTemplateCategoryState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors,
                meta: responseStatus.meta
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, state.formData) : undefined
        }
    });

    return newState;
}

function creating(state: ITrialGroupItemTemplateCategoryState, _isCreating: boolean): ITrialGroupItemTemplateCategoryState {
    const newState: ITrialGroupItemTemplateCategoryState = update(state, {
        createState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function createSuccess(
    state: ITrialGroupItemTemplateCategoryState,
    formData: Dtos.TrialGroupItemTemplateCategory,
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[]
): ITrialGroupItemTemplateCategoryState {
    const newState: ITrialGroupItemTemplateCategoryState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        createState: {
            $set: {
                status: RequestState.Success
            } as IRequestState
        }
    });

    return newState;
}

function createFailure(state: ITrialGroupItemTemplateCategoryState, responseStatus: Dtos.ResponseStatus): ITrialGroupItemTemplateCategoryState {
    const newState: ITrialGroupItemTemplateCategoryState = update(state, {
        createState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors
            } as IRequestState
        }
    });

    return newState;
}

function validating(state: ITrialGroupItemTemplateCategoryState, _isValidating: boolean): ITrialGroupItemTemplateCategoryState {
    const newState: ITrialGroupItemTemplateCategoryState = update(state, {
        validateState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function validateSuccess(
    state: ITrialGroupItemTemplateCategoryState,
    formData: Dtos.TrialGroupItemTemplateCategory,
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus
): ITrialGroupItemTemplateCategoryState {
    const newState: ITrialGroupItemTemplateCategoryState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        validateState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function validateFailure(state: ITrialGroupItemTemplateCategoryState, responseStatus: Dtos.ResponseStatus): ITrialGroupItemTemplateCategoryState {
    const newState: ITrialGroupItemTemplateCategoryState = update(state, {
        validateState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors,
                meta: responseStatus.meta
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, state.formData) : undefined
        }
    });

    return newState;
}

const TrialGroupItemTemplateCategoryReducer: Reducer<ITrialGroupItemTemplateCategoryState> = (state: ITrialGroupItemTemplateCategoryState = initialState, action: TrialGroupItemTemplateCategoryAction) => {
    switch (action.type) {
        case ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_LOAD:
        case ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_LOAD_BY_ID:
            return loading(state, true);
        case ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_LOAD_SUCCESS:
            return loadSuccess(state, action.formData, action.formState, action.formProperties, action.lookups, action.responseStatus);
        case ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_LOAD_FAILURE:
            return loadFailure(state, action.responseStatus);
        case ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_CLEAR:
            return clear(state, action.propertiesToClear);
        case ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_SAVE:
            return saving(state, true);
        case ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_SAVE_SUCCESS:
            return saveSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_SAVE_FAILURE:
            return saveFailure(state, action.responseStatus);
        case ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_CREATE:
            return creating(state, true);
        case ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_CREATE_SUCCESS:
            return createSuccess(state, action.formData, action.formState, action.formProperties, action.lookups);
        case ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_CREATE_FAILURE:
            return createFailure(state, action.responseStatus);
        case ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_VALIDATE:
            return validating(state, true);
        case ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_VALIDATE_SUCCESS:
            return validateSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_VALIDATE_FAILURE:
            return validateFailure(state, action.responseStatus);
        case ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_FILTER:
            return filter(state, action.formFilter);

    }

    return state;
}

export default TrialGroupItemTemplateCategoryReducer;